<app-error-wrapper-inner-component
	[serverErrors]="errorService.errors | async"
	[bundle]="bundleService.bundle | async"
></app-error-wrapper-inner-component>
